import { Grid, IconButton, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import BAGrid from "../config/components/BAGrid";
import BAIconbutton from "../config/components/BAIconbutton";
import { getData } from "../config/firebasemethods";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from '@mui/icons-material/Edit';
import BAModal from "../config/components/BAModal";
import Reciept from "../config/components/reciept";
import BAScreenHeader from "../config/components/BAScreenHeader";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { Delete, Get } from "../config/apimethods/apimethods";
import BAShowError from "../config/components/BAShowerror";
import BAButton from "../config/components/BAButton";
import { setDate } from "../config/core/helpermethod";
import BASearchBar from "../config/components/BASearchbar";
import PaidStamp from '../assets/PaidStamp.png'
import BAPagination from "../config/components/BAPagination";

function AllReciept() {
  const [recepts, setRecepts] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [delModal, setDelModal] = useState(false);
  const [delId, setDelId] = useState(false);
  const [showError, setShowError] = useState(false);
  const [message, setMessage] = useState();
  const [loader, setLoader] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState({});
  const navigate = useNavigate();
  let searchCriterea = {
    pageNo: 1,
    pageSize: 20,
    searchVal: "",
    searchBy: ''
  }
  const [totalCount, setTotalCount] = useState(0)


  let getRecept = () => {
    setLoader(true);
    Get("receipt", null, {
      searchVal: searchCriterea.searchVal,
      pageNo: searchCriterea.pageNo,
      pageLimit: searchCriterea.pageSize,
      searchBy: searchCriterea.searchBy
    })
      .then((res) => {
        setLoader(false);
        setTotalCount(res.count)
        setRecepts([...res.data]);
      })
      .catch((err) => {
        setLoader(false);
        let status = err.response?.status
        if (status == 401) {
          navigate('/login')
        }
      });
  };
  let printInvoice = (e) => {
    setSelectedInvoice(e);
    navigate("/printpage", { state: { model: e } });
  };

  let deleteAnswer = (e) => {
    if (e) {
      delRecept(delId)
    } else {
      setDelModal(false)
      setDelId(null)
    }
  }

  let searchRec = (key, val) => {
    searchCriterea.searchBy = key
    searchCriterea.searchVal = val
    getRecept()
  }


  let delRecept = (id) => {
    Delete("receipt", id)
      .then((res) => {
        console.log(res);
        setMessage("Successfully Deleted");
        setShowError(true);
        getRecept();
        setDelModal(false)
      })
      .catch((err) => {
        setMessage(err);
        setShowError(true);
      });
  };

  useEffect(() => {
    getRecept();
  }, []);
  return (
    <>
      <BAModal
        modalTitle="Are You Sure You want to Delete this Reciept?"
        open={delModal}
        width='30vw'
        close={(e) => setDelModal(e)}
        innerContent={<Box className='d-flex justify-content-around'>
          <BAButton color='warning' onClick={() => deleteAnswer(false)} label='No' />
          <BAButton onClick={() => deleteAnswer(true)} label="Yes" />
        </Box>}
      />
      <BAShowError
        message={message}
        open={showError}
        close={(e) => setShowError(e)}
      />
      <Box>
        <BAScreenHeader
          title="Reciept"
          buttonsList={[
            {
              displayField: <BASearchBar onSearch={(key, val) => {
                searchRec(key, val)
              }} datasourse={[
                {
                  key: 'customerName',
                  value: 'Customer Name'
                },
                {
                  key: 'orderNo',
                  value: 'Order No #'
                },
                {
                  key: 'receiptNo',
                  value: 'Reciept No #'
                },
              ]} />,
            },
            {
              displayField: (
                <IconButton
                  onClick={() => navigate("/createrecept")}
                  color="primary"
                >
                  <AddIcon />
                </IconButton>
              ),
            },
          ]}
        />
        <Box className='py-2'>
          <Box className='listBody'>
            <BAGrid customCard={(e) => <Box
              onClick={(ev) => {
                navigate(`/viewrecept/${e._id}`)
              }} sx={{ minWidth: 200 }} className='p-2 rounded mb-2 cusor-pointer recieptCard bg-white me-2'>
              <Grid container>
                <Grid item md={10}>
                  <Grid container>
                    <Grid item sm={12} xs={12} md={3}>
                      <Box className='border-end p-1 px-3'>
                        <Typography className="fs-14 text-muted">Recipt No #</Typography>
                        <Typography className="fs-6 fw-bold">{e.receiptNo}</Typography>
                      </Box>
                    </Grid>
                    <Grid item sm={12} xs={12} md={3}>
                      <Box className='border-end p-1 px-3'>
                        <Typography className="fs-14 text-muted">Order No #</Typography>
                        <Typography className="fs-6 fw-bold">{e.orderNo}</Typography>
                      </Box>
                    </Grid>
                    <Grid item sm={12} xs={12} md={3}>
                      <Box className='border-end p-1 px-3'>
                        <Typography className="fs-14 text-muted">Customer</Typography>
                        <Typography className="fs-6 fw-bold">{e.customerName}</Typography>
                      </Box>
                    </Grid>
                    <Grid item sm={12} xs={12} md={3}>
                      <Box className='border-end p-1 px-3'>
                        <Typography className="fs-14 text-muted">Date</Typography>
                        <Typography className="fs-6 fw-bold">{setDate(e.createdAt)}</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={2}>
                  <Box className='d-flex align-items-center justify-content-end h-100'>
                    <div>
                      {e.isPaid && <img width="45" src={PaidStamp} alt='Paid' />}
                    </div>
                    {!e.isPaid && <BAIconbutton
                      onClick={(ev) => {
                        ev.stopPropagation()
                        setDelId(e._id)
                        navigate(`/createrecept/${e._id}`)
                      }}
                      icon={<EditIcon />}
                    />}
                    <BAIconbutton
                      color='error'
                      onClick={(ev) => {
                        ev.stopPropagation()
                        setDelId(e._id)
                        setDelModal(true)
                      }}
                      icon={<DeleteIcon />}
                    />
                    <BAIconbutton
                      color='success'
                      onClick={(ev) => {
                        ev.stopPropagation()
                        printInvoice(e)
                      }}
                      icon={<LocalPrintshopIcon />}
                    />

                  </Box>
                </Grid>
              </Grid>




            </Box>}

              loading={loader}
              datasource={recepts}
            />
          </Box>
        </Box>
        <Box>
          <BAPagination loading={loader} onPageChange={(pageNo, pageSize) => {
            searchCriterea.pageNo = pageNo
            searchCriterea.pageLimit = pageSize
            getRecept()
          }} totalCount={totalCount} pageSize={10} />
        </Box>
      </Box>
    </>
  );
}
export default AllReciept;
